import React, { useCallback, useEffect, useRef, useState } from 'react';
import { StyledInput, StyledMaskElement, StyledMaskElementHide } from './BaseInput.styled';
import { useWidthNode } from '../../../../../../../hooks/useWidthNode';
export const BaseInput = ({
  defaultValue,
  inputMode,
  isDisabled,
  onBlur,
  onChange,
  onFocus,
  placeholder,
  value,
  isReadOnly,
  suffixSymbol,
  setRef
}) => {
  var _a;

  const [valueAfterChange, setValueAfterChange] = useState();

  const handleInput = e => {
    setValueAfterChange(e.target.value);
    onChange && onChange(e);
  };

  const inputRef = useRef();
  const cbInputRef = useCallback(node => {
    if (!node) {
      return;
    }

    inputRef.current = node;
    setRef && setRef(node);
  }, []);
  useEffect(() => {
    if (!!inputRef.current && value == inputRef.current.value && value != valueAfterChange) {
      inputRef.current.dispatchEvent(new Event('input', {
        bubbles: true
      }));
    }
  }, [value, valueAfterChange]);
  const [refMaskEl, setRefMaskEl] = useState(null);
  const width = useWidthNode(refMaskEl);
  return React.createElement(React.Fragment, null, !!suffixSymbol && !!((_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.value) && React.createElement(StyledMaskElement, null, React.createElement(StyledMaskElementHide, null, inputRef.current.value), React.createElement("span", {
    ref: setRefMaskEl
  }, "\u00A0", suffixSymbol)), React.createElement(StyledInput, {
    ref: cbInputRef,
    style: {
      paddingRight: width
    },
    "data-value": !!valueAfterChange,
    defaultValue: defaultValue,
    value: value,
    onBlur: onBlur,
    onInput: handleInput,
    onFocus: onFocus,
    placeholder: placeholder,
    type: "text",
    inputMode: inputMode,
    disabled: isDisabled,
    readOnly: isReadOnly
  }));
};